module.exports = __webpack_public_path__ + "img/right-eye.eb12c358.svg";